import {chain as chainOption, getOrElse, map as mapOption, none, some} from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';

const safeParseFloat = (value: string | number | undefined) => {
  let result = value || 0;

  if (typeof result !== 'number') {
    result = parseFloat(result);
  }

  return isNaN(result) ? none : some(result);
};

const toNDecimalPlaces = (decimalPlaces: number) => (value: number) => value.toFixed(decimalPlaces);

export const toMoneyValue = (value: string | number | undefined) =>
  pipe(
    some(value),
    chainOption(safeParseFloat),
    mapOption(toNDecimalPlaces(2)),
    mapOption(parsedMoneyValue => `$${parsedMoneyValue}`),
    getOrElse(() => '$0.00')
  );
